async function withDuration(functionName, func, logger) {
  const start = Date.now();
  const result = await func();
  logger.log(
    `${functionName} duration: ${
      Date.now() - start
    }ms and in human readble format: ${(Date.now() - start) / 1000} s`
  );
  return result;
}

module.exports = {
  withDuration,
};
